/**
 * header-uqam.js
 */

// Import
import "./header-uqam.scss";
import $ from 'jquery';

$(document).ready(function() {

});